import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { reconciliationApi } from '../api/reconciliationApi';
import { useToast } from '../../../shared/components/toast/useToast';
import type { DiscrepancyFilter } from '../types';

const errMsg = (err: unknown, fallback: string) => ((err as Error)?.message) || fallback;

export const useDiscrepancies = (filter?: DiscrepancyFilter) =>
  useQuery({
    queryKey: ['reconciliation', 'discrepancies', filter],
    queryFn: () => reconciliationApi.listDiscrepancies(filter),
    staleTime: 60 * 1000,
  });

export const useRunReconciliation = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: ({ provider, period }: { provider: string; period: string }) =>
      reconciliationApi.run(provider, period),
    onSuccess: (count) => {
      queryClient.invalidateQueries({ queryKey: ['reconciliation'] });
      toast.success(`Reconciliation complete — ${count} discrepanc${count === 1 ? 'y' : 'ies'} found`);
    },
    onError: (err: unknown) => toast.error(errMsg(err, 'Failed to run reconciliation')),
  });
};
